<template>
  <div class="timeline">
    <div class="timeline__box">
      <header class="timeline__box__header">
        <ui-button
          class="timeline__box__header__close"
          @click.prevent="toggleTimeline(false)"
          button="secondary"
          :label="$t('commons.buttons.close')"
          :icon-only="true"
          icon="close"
        />
        <div class="timeline__box__header__title">
          {{ $t('timeline.title') }}
        </div>
      </header>
      <div class="timeline__box__container">
        <div class="timeline__box__container__section">
          <div
            class="timeline__box__container__description"
            v-html="$t('timeline.description', { timeline: formatDate(timelineKpi[0], locale, 'LL') })"
          ></div>
          <vue-slider
            class="timeline__box__container__section__slider"
            :value="timelineSelect"
            tooltip="focus"
            :data="timelineKpi"
            :dragOnClick="true"
            :clickable="false"
            :dotSize="24"
            :enable-cross="false"
            :adsorb="true"
            :tooltip-formatter="value => formatDate(value, locale, 'DD MMM YY')"
            tooltipPlacement="bottom"
            :rail-style="{
              backgroundColor: '#ddd',
              height: '6px',
            }"
            :dot-style="{
              backgroundColor: '#00a74b',
              border: '2px solid #fff',
              boxShadow: 'none',
            }"
            :step-active-style="{
              backgroundColor: '#00a74b',
            }"
            :step-style="{
              backgroundColor: '#ddd',
              width: '14px',
              height: '14px',
              transform: 'translate(calc(-50% + 3px), calc(-50% + 3px))',
            }"
            :process-style="{ backgroundColor: '#00a74b' }"
            :tooltip-style="{
              backgroundColor: '#00a74b',
              borderColor: '#00a74b',
              fontSize: '0.75rem',
              fontWeight: 'bold',
              padding: '4px 8px',
            }"
            :marks="marksTimeline"
            @dragging="updateTimeline"
            @change="updateTimeline"
            @drag-end="$emit('refreshLocations')"
          ></vue-slider>
        </div>
      </div>
      <footer class="timeline__box__footer">
        <ui-button
          class="timeline__box__footer__close"
          :label="$t('commons.buttons.close')"
          button="primary"
          @click.prevent="toggleTimeline(false)"
        />
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UiButton from '@/components/UI/Button.vue'
import VueSlider from 'vue-slider-component'
import { formatDate } from '@/utils/date.util'

export default {
  name: 'Timeline',
  components: {
    UiButton,
    VueSlider,
  },
  props: {
    timelineKpi: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formatDate,
    }
  },
  created() {
    this.marksTimeline = value => {
      if (value === this.timelineKpi[this.timelineKpi.length - 1]) {
        return {
          label: this.$t('timeline.now'),
          labelStyle: {
            fontSize: '0.75rem',
            marginTop: '0',
            padding: '12px 0 0',
          },
        }
      }
      return {
        label: formatDate(value, this.locale, 'DD MMM YY'),
        labelStyle: {
          fontSize: '0.75rem',
          marginTop: '0',
          padding: '12px 0 0',
        },
      }
    }
  },
  computed: {
    ...mapState({
      currentTimeline: state => state.refine.currentTimeline,

      settings: state => state.radar.settings,
      filters: state => state.radar.filters,
      locale: state => state.radar.locale,
    }),
    timelineSelect() {
      return this.currentTimeline || this.timelineKpi[this.timelineKpi.length - 1]
    },
  },
  methods: {
    ...mapActions({
      toggleTimeline: 'radar/toggleTimeline',

      updateCurrentTimeline: 'refine/updateCurrentTimeline',

      setCurrentLocation: 'data/setCurrentLocation',
    }),
    updateTimeline(timeline) {
      this.updateCurrentTimeline(timeline)
    },
  },
}
</script>

<style lang="scss">
.vue-slider-mark {
  cursor: pointer;
}

.vue-slider-mark:first-child .vue-slider-mark-step,
.vue-slider-mark:last-child .vue-slider-mark-step {
  display: inherit;
}

.timeline {
  @include wrapper(flex-start, $gutter-md);

  @media (min-width: $screen-sm) {
    right: initial;
    bottom: initial;
    width: 100%;
  }

  &__box {
    @include box;

    width: 100%;

    &__header {
      @include header;

      &__close {
        @include close;
      }

      &__title {
        @include title;
      }
    }

    &__container {
      @include container($spacing-sm);

      &__section {
        padding-bottom: 20px;

        &__slider {
          margin-top: $spacing-sm;

          .vue-slider-mark {
            &:first-child .vue-slider-mark-label {
              left: 0;
              transform: translateX(0);
            }

            &:last-child .vue-slider-mark-label {
              transform: translateX(-100%);
              text-align: right;
            }
          }
        }
      }
    }

    &__footer {
      @include footer;

      @media (min-width: $screen-sm) {
        display: none;
      }
    }
  }
}
</style>
